/** Single locale for every user-facing date/number — pages must not pick their own. */
export const APP_LOCALE = 'en-GB';

/**
 * Today (or any date) as YYYY-MM-DD in the user's local timezone.
 * `toISOString().slice(0, 10)` is UTC and yields yesterday between local
 * midnight and UTC midnight — never use it for date-input defaults.
 */
export function localISODate(d: Date = new Date()): string {
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

export function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString(APP_LOCALE, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(dateStr: string): string {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleString(APP_LOCALE, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Rounded integer with thousands separators in the app locale. */
export function formatInt(n: number): string {
  return Math.round(n).toLocaleString(APP_LOCALE);
}

export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null) return '—';
  const s = Math.max(0, Math.round(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

export function computePace(
  distance: number | null | undefined,
  duration: number | null | undefined,
): string | null {
  if (distance == null || duration == null || distance <= 0) return null;
  const secPerKm = duration / distance;
  const m = Math.floor(secPerKm / 60);
  const s = Math.round(secPerKm % 60);
  return `${m}:${String(s).padStart(2, '0')} /km`;
}

export function formatNum(n: number): string {
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}
